import React, { useEffect, useState } from 'react';
import { useDevice } from 'hooks';

function DeviceDebug() {
	const { items, handleGetDebug, handleClearDebug } = useDevice();
	const [search, setSearch] = useState('');
	const [collapsedModules, setCollapsedModules] = useState({});
	const [expandedDevices, setExpandedDevices] = useState({});

	useEffect(() => {
		handleGetDebug();
		return () => handleClearDebug();
	}, []);

	const toggleModule = (moduleId) =>
		setCollapsedModules((prev) => ({ ...prev, [moduleId]: !prev[moduleId] }));

	const toggleDevice = (key) =>
		setExpandedDevices((prev) => ({ ...prev, [key]: !prev[key] }));

	const matchesSearch = (deviceKey, device) => {
		const q = search.toLowerCase();
		return (
			deviceKey.toLowerCase().includes(q) ||
			(device.name || '').toLowerCase().includes(q) ||
			(device.description || '').toLowerCase().includes(q)
		);
	};

	const filteredModules = () => {
		if (!items) return [];
		return Object.entries(items)
			.map(([moduleId, devices]) => {
				const filtered = Object.entries(devices).filter(([key, device]) =>
					matchesSearch(key, device)
				);
				return [moduleId, filtered];
			})
			.filter(([, devices]) => devices.length > 0);
	};

	const renderDeviceDetails = (device) => {
		return (
			<tr>
				<td colSpan={3} className="p-0">
					<table className="table table-sm mb-0 bg-light">
						<tbody>
							{Object.entries(device).map(([k, v]) => (
								<tr key={k}>
									<td className="ps-4 text-muted" style={{ width: '30%' }}>
										{k}
									</td>
									<td>
										<code>
											{typeof v === 'object'
												? JSON.stringify(v, null, 2)
												: String(v)}
										</code>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</td>
			</tr>
		);
	};

	const renderModule = (moduleId, devices) => {
		const isCollapsed = collapsedModules[moduleId];

		return (
			<div key={moduleId} className="card mb-2">
				<div
					className="card-header d-flex justify-content-between align-items-center"
					style={{ cursor: 'pointer' }}
					onClick={() => toggleModule(moduleId)}
				>
					<strong>{moduleId}</strong>
					<span className="badge bg-secondary">{devices.length}</span>
				</div>

				{!isCollapsed && (
					<div className="table-responsive">
						<table className="table table-hover table-sm mb-0">
							<thead className="table-light">
								<tr>
									<th style={{ width: '25%' }}>Key</th>
									<th style={{ width: '25%' }}>Name</th>
									<th>Description</th>
								</tr>
							</thead>
							<tbody>
								{devices.map(([deviceKey, device]) => {
									const expandKey = `${moduleId}.${deviceKey}`;
									const isExpanded = expandedDevices[expandKey];
									return (
										<React.Fragment key={deviceKey}>
											<tr
												style={{ cursor: 'pointer' }}
												onClick={() => toggleDevice(expandKey)}
											>
												<td className="text-muted font-monospace">
													{deviceKey}
												</td>
												<td>{device.name || '—'}</td>
												<td className="d-flex justify-content-between">
													<span>{device.description || '—'}</span>
													<span className="text-muted">
														{isExpanded ? '▲' : '▼'}
													</span>
												</td>
											</tr>
											{isExpanded && renderDeviceDetails(device)}
										</React.Fragment>
									);
								})}
							</tbody>
						</table>
					</div>
				)}
			</div>
		);
	};

	const modules = filteredModules();

	return (
		<main className="container">
			<div className="d-flex align-items-center justify-content-between my-4">
				<h1 className="mb-0">Devices</h1>
				<input
					type="search"
					className="form-control w-auto"
					placeholder="Search..."
					value={search}
					onChange={(e) => setSearch(e.target.value)}
				/>
			</div>

			{modules.length === 0 ? (
				<p className="text-muted">No devices found.</p>
			) : (
				modules.map(([moduleId, devices]) => renderModule(moduleId, devices))
			)}
		</main>
	);
}

export default DeviceDebug;
